<div nz-row class="my-account first-section">
  <div nz-col nzSpan="16" [ngClass]="'p-3 text-welcome'">
    <h1 nz-typography>Bun venit, dragă {{ currentUser.firstname }}!</h1>
    <p>Ştiu că te preocupă viitorul AFACERII tale!</p>
    <p>
      Sunt lângă tine în fiecare lună, ca să
      <br />
      dau sens cifrelor business-ului tău.
    </p>
  </div>

  <div nz-col nzSpan="16" [ngClass]="'p-3 upload-buttons'">
    <!-- <div class="btn-row-1">
            <a href="https://app.doctorbusiness.ro/upload">
                <img src="/assets/img/btn-sms-clean.png">
            </a>
            <a href="https://app.doctorbusiness.ro/upload">
                <img src="/assets/img/btn-card-clean.png">
            </a>
        </div> -->
    <div class="btn-row-2">
      <a [href]="frontendUploadUrl">
        <!-- <img src="/assets/img/btn-incarca.png" /> -->
        <button class="evolution-button">
          ÎNCARCĂ BALANŢA
          <span class="button-custom-icon" style="position: relative; top: 5px">
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF">
              <path
                d="M445-80q-29 0-56-12t-45-35L127-403l21-23q14-15 34.5-18.5T221-438l99 53v-365q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v465l-144-77 156 198q10 12 23.76 18 13.76 6 29.24 6h205q38 0 64-26t26-64v-170q0-25.5-17.25-42.75T680-460H460v-60h219.65q50.14 0 85.25 35 35.1 35 35.1 85v170q0 63-43.5 106.5T650-80H445ZM203-665q-11.07-18.75-17.04-40.49-5.96-21.74-5.96-44.76 0-70.75 49.73-120.25Q279.45-920 350-920t120.27 49.74Q520-820.52 520-749.96q0 22.96-5.96 44.62Q508.07-683.68 497-665l-52-30q7-12 11-26t4-29.48Q460-796 427.88-828q-32.12-32-78-32T272-827.92q-32 32.09-32 77.92 0 15 4 29t11 26l-52 30Zm285 335Z" />
            </svg>
          </span>
        </button>
      </a>
    </div>
  </div>
</div>

<div nz-row class="my-account-content">
  <div nz-col nzSpan="22" nzOffset="1" [ngClass]="'p-3'">
    <div class="top-files-content">
      <h5 class="credits-text">
        <ng-container *ngIf="unlimitedSubscription">Ai un abonament nelimitat activ pana la
          {{subscriptionEndDate | date: 'dd.MM.yyyy'}}.</ng-container>
        <ng-container *ngIf="!unlimitedSubscription">
          Conform plăţilor efectuate mai ai
          <br />
          disponibile
          <b>{{ totalBalante }}</b>
          încărcări de balanţă.
        </ng-container>
      </h5>
      <!-- <div class="pagination">
                <nz-pagination [(nzPageIndex)]="pageIndex" [nzTotal]="totalPages"
                [nzPageSizeOptions]="[10,20,30,40,100]"
                    (nzPageIndexChange)="pageIndexChanged($event)" nzShowSizeChanger [nzPageSize]="pageSize"
                    (nzPageSizeChange)="pageSizeChanged($event)"></nz-pagination>
            </div> -->
    </div>
  </div>
</div>
<div nz-row class="my-account-content">
  <div nz-col nzSpan="22" nzOffset="1" [ngClass]="'p-3'">
    <nz-checkbox-wrapper style="width: 100%" (nzOnChange)="toggleCompare($event)">
      <nz-spin [nzSpinning]="loading">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div></div>
          <nz-pagination class="custom-pagination" [(nzPageIndex)]="pageIndex" [nzTotal]="totalPages"
            [nzPageSizeOptions]="[10, 20, 30, 40, 100]" (nzPageIndexChange)="pageIndexChanged($event)" nzShowSizeChanger
            [nzPageSize]="pageSize" (nzPageSizeChange)="pageSizeChanged($event)"></nz-pagination>
        </div>
        <!-- Mobile button - visible only on mobile, centered above table -->
        <div class="compare-btn-mobile">
          <button nz-button nzType="primary" class="big-button" nzShape="round" [disabled]="checkCompare.length < 2"
            (click)="loadCompare()"
            nz-tooltip nzTooltipTitle="Bifați căsuțele mov pentru selectarea rapoartelor de comparat">
            Compară Perioade
          </button>
        </div>

        <!-- Desktop button - hidden on mobile -->
        <div class="compare-btn-desktop" style="position: relative;">
          <div style="position: absolute; top: -65px; left: 645px; z-index: 10;" *ngIf="userRole == 'admin'">
            <button nz-button nzType="primary" class="big-button" nzShape="round" [disabled]="checkCompare.length < 2"
              (click)="loadCompare()"
              nz-tooltip nzTooltipTitle="Bifați căsuțele mov pentru selectarea rapoartelor de comparat">
              Compară Perioade
            </button>
          </div>
          <div style="position: absolute; top: -65px; left: 525px; z-index: 10;" *ngIf="userRole == 'user'">
            <button nz-button nzType="primary" class="big-button" nzShape="round" [disabled]="checkCompare.length < 2"
              (click)="loadCompare()"
              nz-tooltip nzTooltipTitle="Bifați căsuțele mov pentru selectarea rapoartelor de comparat">
              Compară Perioade
            </button>
          </div>
        </div>
        <nz-table #filesTable [nzData]="filesDataToDisplay" [nzFrontPagination]="false"
          [nzScroll]="userRole == 'admin' ? { x: '2300px' } : ''">
          <thead>
            <tr>
              <th *ngIf="userRole != 'user'" nzWidth="100px">ID</th>
              <th nzWidth="120px" class="th-two-rows">Raport detaliat</th>
              <th nzWidth="100px" class="th-two-rows">Raport pe scurt</th>
              <th nzWidth="100px" class="th-two-rows">Raport in engleza</th>
              <th nzWidth="120px" class="th-two-rows">Diagnostic financiar</th>
              <th *ngIf="userRole != 'user'" nzCustomFilter nzWidth="170px" nz-tooltip="Filtru pentru data balantei">
                <nz-date-picker nzBorderless nzMode="month" [(ngModel)]="searchValueDate" nzPlaceHolder="DATA BALANTEI"
                  (ngModelChange)="filterBy()"></nz-date-picker>
              </th>
              <th *ngIf="userRole == 'user'" nzWidth="150px" style="text-align: center">Data balanţei</th>
              <th nzWidth="120px" style="text-align: center">
                Selectează pentru comparaţie
              </th>
              <th nzWidth="220px" nzCustomFilter style="text-align: center">
                <input nz-input placeholder="STATUS" nzBorderless (keyup)="filterBy()"
                  [(ngModel)]="searchValueMessage" />
              </th>
              <!-- <th nzCustomFilter>
                        <input nz-input placeholder="Balanţele mele" nzBorderless (keyup)="searchBalante()"
                            [(ngModel)]="searchValueBalante">
                    </th> -->
              <!-- <th style="text-align: center" nzWidth="170px">Data încărcării</th> -->
              <th nzCustomFilter nzWidth="170px" nz-tooltip="Filtru pentru data încărcării">
                <nz-date-picker nzBorderless nzMode="month" [(ngModel)]="searchUploadDate"
                  nzPlaceHolder="DATA ÎNCĂRCĂRII" (ngModelChange)="filterBy()"></nz-date-picker>
              </th>
              <th nzWidth="70px" *ngIf="userRole != 'user'" style="text-align: center">Download</th>
              <th *ngIf="userRole != 'user'" nzCustomFilter nzWidth="150px">
                <input nz-input placeholder="Utilizator" nzBorderless (keyup)="filterBy()"
                  [(ngModel)]="searchValueName" />
              </th>
              <th *ngIf="userRole != 'user'" nzCustomFilter nzWidth="150px">
                <input nz-input placeholder="Procesator" nzBorderless (keyup)="filterBy()"
                  [(ngModel)]="searchValueProcessedName" />
              </th>
              <th *ngIf="userRole != 'user'" nzCustomFilter nzWidth="220px">
                <input nz-input placeholder="Email" nzBorderless (keyup)="filterBy()" [(ngModel)]="searchValueEmail" />
              </th>
              <th *ngIf="userRole != 'user'" nzWidth="150px">Alocare raport la utilizator</th>
              <th style="text-align: center" nzCustomFilter><input nz-input placeholder="Notitele mele" nzBorderless
                  (keyup)="filterBy()" [(ngModel)]="searchValueNotite" /></th>
              <th class="th-two-rows" nzWidth="110px">Stergere procesare</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of filesTable.data; let i = index">
              <ng-container *ngIf="(file.visible == 1 && userRole == 'user') || userRole != 'user'">
                <td *ngIf="userRole != 'user'">
                  {{ file.id }}
                  <button *ngIf="userRole != 'user'" nz-button nzType="default" nzShape="circle" nz-tooltip
                    nzTooltipTitle="Informaţii fişier" (click)="infoModal(tplInfoModal, tplInfoModalFooter, i)">
                    <i nz-icon nzType="info"></i>
                  </button>
                </td>
                <td style="text-align: center">
                  <button *ngIf="userRole != 'user'" nz-button nzType="default" nzShape="circle" nz-tooltip
                    nzTooltipTitle="Proceseaza fişier" (click)="processFile(file)">
                    <i nz-icon nzType="reload" nzTheme="outline"></i>
                  </button>

                  <a (click)="openFile(0, file)" nz-button nzType="primary" nzShape="circle" nz-tooltip
                    nzTooltipTitle="Vizualizare rezultate" *ngIf="file.balanceProcessError == 0 || userRole != 'user'">
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                  </a>
                </td>
                <td style="text-align: center">
                  <a (click)="openFile(1, file)" nz-button nzType="primary" nzShape="circle" nz-tooltip
                    nzTooltipTitle="Vizualizare rezultate" *ngIf="file.balanceProcessError == 0 || userRole != 'user'"
                    style="background-color: #3e6ce9">
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                  </a>
                </td>
                <td style="text-align: center">
                  <a (click)="openFile(0, file, 'en')" nz-button nzType="primary" nzShape="circle" nz-tooltip
                    nzTooltipTitle="Vizualizare rezultate Engleza"
                    *ngIf="file.balanceProcessError == 0 || userRole != 'user'" style="background-color: #701470">
                    <span>EN</span>
                  </a>
                </td>
                <td style="text-align: center">
                  <a (click)="openDiagnostic(file)" nz-button nzType="primary" nzShape="circle" nz-tooltip
                    nzTooltipTitle="Vizualizare diagnostic financiar"
                    *ngIf="file.balanceProcessError == 0 || userRole != 'user'" style="background-color: #8aa70b">
                    <span style="position: relative; top: 4px">
                      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"
                        fill="#EFEFEF">
                        <path
                          d="M336-480v-72h288v72H336Zm0-144v-72h288v72H336Zm-72 240h276q25.98 0 48.38 10.94Q610.77-362.13 626-342l70 92v-542H264v408Zm0 216h404l-98.57-129.74Q564-305 556-308.5t-16-3.5H264v144Zm431.96 72H263.72Q234-96 213-117.15T192-168v-624q0-29.7 21.16-50.85Q234.32-864 264.04-864h432.24Q726-864 747-842.85T768-792v624q0 29.7-21.16 50.85Q725.68-96 695.96-96ZM264-168v-624 624Zm0-144v-72 72Z" />
                      </svg>
                    </span>
                  </a>
                </td>
                <td style="text-align: center">{{ months[file.month] }} - {{ file.year }}</td>
                <td style="text-align: center">
                  <ng-container *ngIf="file.balanceProcessError == 0">
                    <label nz-checkbox [nzValue]="file" [ngModel]="false"></label>
                    <!-- <nz-checkbox-group [(ngModel)]="checkCompare"  (ngModelChange)="toggleCompare(file.id)">x</nz-checkbox-group> -->
                  </ng-container>
                </td>

                <ng-container *ngIf="userRole != 'user'">
                  <td *ngIf="file.balanceProcessError != 0" nz-typography nzType="danger">
                    <ng-container *ngIf="file.balanceProcessError == 5">{{ file.balanceProcessMessage }}</ng-container>
                    <ng-container *ngIf="file.balanceProcessError != 5 && file.balanceProcessError != undefined">
                      <div *ngFor="let x of errorMessages | errorfilter : file.balanceProcessError">
                        {{ x.adminMessage }}
                      </div>
                    </ng-container>
                  </td>
                  <td *ngIf="file.balanceProcessError == 0" nz-typography nzType="success">
                    {{ file.balanceProcessMessage }}
                  </td>
                </ng-container>
                <ng-container *ngIf="userRole == 'user'">
                  <td *ngIf="file.balanceProcessError != 0" nz-typography nzType="danger">
                    <div *ngFor="let x of errorMessages | errorfilter : file.balanceProcessError"
                      [innerHtml]="x.userMessage"></div>
                    <!-- {{x.userMessage }}-->
                  </td>
                  <td *ngIf="file.balanceProcessError == 0" nz-typography nzType="success">Procesare cu success</td>
                </ng-container>
                <!-- <td>{{ file.file }}</td> -->
                <td style="text-align: center">
                  {{ file.dateCreated | momentDate }}
                </td>
                <th *ngIf="userRole != 'user'">
                  <button nz-button nzType="default" nzShape="circle" nz-tooltip
                    nzTooltipTitle="Obtine link-ul pentru a salva balanta" *ngIf="!downloadURL"
                    (click)="getDownloadUrl(file)">
                    <i nz-icon nzType="delivered-procedure" nzTheme="outline"></i>
                  </button>

                  <ng-container *ngIf="file == fileMarkedForDownload">
                    <div *ngIf="downloadURL | async; let url">
                      <a [href]="url" target="_blank" (click)="downloadFile()" nz-tooltip
                        nzTooltipTitle="Salveaza balanta">
                        <i nz-icon nzType="save" nzTheme="fill"></i>
                      </a>
                    </div>
                  </ng-container>
                </th>
                <td *ngIf="userRole != 'user'">{{ file.userFirstName }} {{ file.userLastName }}</td>
                <td *ngIf="userRole != 'user'">
                  {{ file.userProcessedFirstName }}
                  {{ file.userProcessedLastName }}
                </td>

                <td *ngIf="userRole != 'user'">{{ file.userEmail }}</td>
                <td style="text-align: center" *ngIf="userRole != 'user'">
                  <i nz-icon nzType="user-switch" nzTheme="outline" *ngIf="!showSelectUser"
                    (click)="toggleShowSelectUser(file.IDBalanceProcessed)" style="cursor: pointer"></i>

                  <nz-select class="custom-pagination" style="color: black !important"
                    *ngIf="showSelectUser && file.IDBalanceProcessed == showSelectUser" nzShowSearch nzAllowClear
                    nzPlaceHolder="Selecteaza adresa de email" [(ngModel)]="selectedUser" [nzLoading]="isLoading"
                    (nzOnSearch)="onSearch($event)" (ngModelChange)="onSelectUser($event)"
                    nz-tooltip="Introduceți un nume pentru a vedea rezultatele. Începeți să tastați numele utilizatorului pentru filtrare">
                    <nz-option *ngFor="let option of listOfUsers" [nzLabel]="option.label"
                      [nzValue]="option.value"></nz-option>
                  </nz-select>

                  <i nz-icon nzType="save" nzTheme="fill"
                    *ngIf="showSelectUser && file.IDBalanceProcessed == showSelectUser && selectedUser != undefined"
                    (click)="saveChangedUser(file.id)" style="cursor: pointer"></i>
                </td>
                <td style="text-align: center">
                  <ng-container *ngIf="!showEditNotes">{{ file.notes }}</ng-container>
                  <span nz-icon nzType="edit" nzTheme="outline"
                    *ngIf="!showEditNotes && file.userCreated == currentUserInfo.sub"
                    (click)="toggleShowEditNotes(file.IDBalanceProcessed)" style="cursor: pointer"></span>
                  <ng-container *ngIf="showEditNotes && file.IDBalanceProcessed == showEditNotes">
                    <textarea nz-input style="width: 200px" placeholder="Adauga notitele tale" [(ngModel)]="notes"
                      [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
                  </ng-container>
                  <i nz-icon nzType="save" nzTheme="fill"
                    *ngIf="showEditNotes && file.IDBalanceProcessed == showEditNotes" (click)="saveNotes(file.id)"
                    style="cursor: pointer"></i>
                </td>
                <td style="text-align: center">
                  <button nz-button style="background-color: rgb(255, 93, 93)" (click)="fileVisible(file.id)"
                    *ngIf="file.visible == 0 && userRole != 'user'" nzShape="circle">
                    <span nz-icon nzType="delete"></span>
                  </button>
                  <button nz-button nzType="primary" *ngIf="file.visible == 1" nzShape="circle" nz-popconfirm
                    nzPopconfirmTitle="Esti sigur ca vrei sa stergi aceasta procesare?" nzPopconfirmPlacement="bottom"
                    (nzOnConfirm)="fileVisible(file.id)">
                    <span nz-icon nzType="delete"></span>
                  </button>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </nz-table>
      </nz-spin>
    </nz-checkbox-wrapper>
  </div>
</div>

<div nz-row class="my-account-pagination">
  <div nz-col nzSpan="20" nzOffset="3" [ngClass]="'p-3'" style="text-align: right">
    <div class="pagination">
      <nz-pagination class="custom-pagination" [(nzPageIndex)]="pageIndex" [nzTotal]="totalPages"
        [nzPageSizeOptions]="[10, 20, 30, 40, 100]" (nzPageIndexChange)="pageIndexChanged($event)" nzShowSizeChanger
        [nzPageSize]="pageSize" (nzPageSizeChange)="pageSizeChanged($event)"></nz-pagination>
    </div>
  </div>
</div>

<div style="text-align: center; margin-bottom: 20px">
  <ul nz-menu nzTheme="light" nzMode="horizontal" style="text-align: center">
    <li nz-menu-item>
      <a routerLink="/tranzactii" class="nav-item nav-link">Tranzacţiile mele</a>
    </li>
  </ul>
</div>

<ng-template #tplInfoModal let-params>
  <p>
    <b>Nume fişier:</b>
    {{ infoFile.file }}
  </p>
</ng-template>
<ng-template #tplInfoModalFooter></ng-template>
